<template lang="pug">
  PhoValidationProvider(name="category" :rules="rules")
    v-autocomplete(
      v-model="lazyValue"
      dense
      multiple
      clearable
      outlined
      attach
      item-value="id"
      item-text="displayName"
      :disabled="disabled"
      :items="lazyCategories"
      :label="$t($lang.content.CATEGORY)"
      :placeholder="placeholder"
      :search-input.sync="search"
      :menu-props="{maxHeight:150}"
      @change="clearSearch"
    )
      template(v-slot:selection='{ item }')
          div(:class="item.class" class="v-select__selection v-select__selection--comma list-with-comma") {{ `${item.displayName}` }}
      template(v-slot:item='{ active, item, attrs, on }')
        div(class="v-list-item__content")
          div(class="v-list-item__title" :class="item.class") {{ item.displayName }}
</template>

<script>
import { PhoValidationProvider } from '@/components/misc/form';
import {
  ref, onMounted, computed, watch,
} from 'vue';
import { useSelectedSorter } from '@/helpers/misc';
import { useModelAutoBinding } from '@/helpers/misc/binding';
import { filterSelectedValues } from '@/helpers/content';
import { getMainCategories } from '@/api/category/CategoryApi';

export default {
  name: 'MainCategories',
  components: {
    PhoValidationProvider,
  },
  props: {
    value: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    rules: {
      type: String,
      default: '',
    },
    mediumIdFilter: {
      type: [Number, String],
      default: null,
    },
  },
  setup(props, { emit }) {
    const { lazyValue } = useModelAutoBinding(emit, props);

    const previouslySelectedIds = ref([]);
    const allCategories = ref([]);
    const search = ref('');

    const clearSearch = () => {
      search.value = '';
    };

    const lazyItems = computed(() => {
      const categoriesToShow = allCategories.value.filter(item => {
        const isApprovedOrPreviouslySelected = item.isApproved || previouslySelectedIds.value.includes(item.id);

        if (!isApprovedOrPreviouslySelected) {
          return false;
        }

        if (props.mediumIdFilter == null) {
          return true;
        }

        const matchesMedium = Number(item.mediumId) === Number(props.mediumIdFilter);
        const isCurrentlySelected = (lazyValue.value || []).includes(item.id);

        return matchesMedium || isCurrentlySelected;
      });
      categoriesToShow.forEach(item => {
        item.class = item.isApproved ? '' : 'red--text';
      });

      return categoriesToShow;
    });

    watch(lazyValue, () => {
      previouslySelectedIds.value = [...(previouslySelectedIds.value || []), ...(lazyValue.value || [])];
    });

    onMounted(async () => {
      allCategories.value = await getMainCategories();
    });

    const [lazyCategories] = useSelectedSorter(lazyItems, lazyValue, filterSelectedValues, 'id');

    return {
      search,
      lazyValue,
      lazyItems,
      allCategories,
      lazyCategories,
      clearSearch,
    };
  },
};
</script>
